import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { SolarPaybackBootstrapModule } from './lib/solar-payback.bootstrap.module';

const loadChildren = () =>
  import('./lib/solar-payback.lazy.module').then(
    (module) => module.SolarPaybackLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const solarPaybackLazyImports: ComponentNameAndModule[] = [
  defineImport('SolarPaybackWizard'),
];

export { solarPaybackLazyImports, SolarPaybackBootstrapModule };
